var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapUserIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2487 3.8335C12.227 3.8335 8.14453 7.916 8.14453 12.9377C8.14453 17.8635 11.997 21.8502 17.0187 22.0227C17.172 22.0035 17.3254 22.0035 17.4404 22.0227C17.4787 22.0227 17.4979 22.0227 17.5362 22.0227C17.5554 22.0227 17.5554 22.0227 17.5745 22.0227C22.4812 21.8502 26.3337 17.8635 26.3529 12.9377C26.3529 7.916 22.2704 3.8335 17.2487 3.8335Z",
    fill: "url(#paint0_linear_6206_112329)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9878 27.121C21.6403 23.556 12.9195 23.556 7.53365 27.121C5.09948 28.7502 3.75781 30.9543 3.75781 33.3118C3.75781 35.6693 5.09948 37.8544 7.51448 39.4644C10.1978 41.266 13.7245 42.1669 17.2511 42.1669C20.7778 42.1669 24.3045 41.266 26.9878 39.4644C29.4028 37.8352 30.7445 35.6502 30.7445 33.2735C30.7253 30.916 29.4028 28.731 26.9878 27.121Z",
    fill: "url(#paint1_linear_6206_112329)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.313 14.0682C38.6196 17.7865 35.9746 21.0449 32.3138 21.4857C32.2946 21.4857 32.2946 21.4857 32.2755 21.4857H32.218C32.103 21.4857 31.988 21.4857 31.8921 21.524C30.033 21.6199 28.3271 21.0257 27.043 19.9332C29.0171 18.1699 30.148 15.5249 29.918 12.6499C29.7838 11.0974 29.2471 9.67903 28.4421 8.47153C29.1705 8.10737 30.0138 7.87737 30.8763 7.8007C34.633 7.47487 37.9871 10.2732 38.313 14.0682Z",
    fill: "url(#paint2_linear_6206_112329)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1458 31.7974C41.9925 33.6566 40.8042 35.2666 38.8108 36.3591C36.8942 37.4133 34.4792 37.9116 32.0833 37.8541C33.4633 36.6083 34.2683 35.0558 34.4217 33.4074C34.6133 31.0308 33.4825 28.7499 31.2208 26.9291C29.9367 25.9133 28.4417 25.1083 26.8125 24.5141C31.0483 23.2874 36.3767 24.1116 39.6542 26.7566C41.4175 28.1749 42.3183 29.9574 42.1458 31.7974Z",
    fill: "url(#paint3_linear_6206_112329)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6206_112329",
    x1: 17.2487,
    y1: 3.8335,
    x2: 17.2487,
    y2: 22.0227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39B6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D88D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6206_112329",
    x1: 17.2511,
    y1: 24.4473,
    x2: 17.2511,
    y2: 42.1669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39B6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D88D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6206_112329",
    x1: 32.6901,
    y1: 7.7749,
    x2: 32.6901,
    y2: 21.5341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39B6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D88D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6206_112329",
    x1: 34.4896,
    y1: 23.9575,
    x2: 34.4896,
    y2: 37.8586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39B6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D88D0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapUserIcon);
export default __webpack_public_path__ + "static/media/map-user-icon.04d578560aedda48c1073017e3622ca0.svg";
export { ForwardRef as ReactComponent };